import { useEffect, useState } from 'react';

const useModal = (isVisible?: boolean) => {
  const [isModalOpen, setIsModalOpen] = useState(isVisible || false);

  useEffect(() => {
    if (isVisible) setIsModalOpen(isVisible);
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isVisible]);
  const openModal = () => {
    document.body.style.overflow = 'hidden';
    setIsModalOpen(true);
  };

  const closeModal = () => {
    document.body.style.overflow = 'auto';
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    openModal,
    closeModal,
  };
};

export default useModal;
